import React, { useState } from 'react';
import { Formik, Field } from 'formik';
import {
  Button,
  Form,
  Container,
  FormGroup,
  Row,
  CardGroup,
  Card,
  CardBody,
  Col
} from 'reactstrap';
import * as Yup from 'yup';
//component
import InputField from '../../../reusable-components/InputField';
//utils
import APIUtil from '../../../api/apiUtil';
import Loader from '../../../reusable-components/Loader';
import { successAlert, errorAlert } from '../../../utils/alert';
import { useAuth } from '../../../AuthProvider';
import { authActionType as actionTypes } from '../../../constants';

const api = new APIUtil();

//This schema helps in validating the form.
const LoginSchema = Yup.object().shape({
  email: Yup.string().email('Invalid Email').required('*Required'),
  password: Yup.string().trim().required('*Required')
});
export default function Login() {
  const [loading, setLoading] = useState(false);
  const [, dispatch] = useAuth();
  const handleSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    
    try {
      const { data } = await api.post('user/login', values);
      console.log({ data });
      successAlert(data.message);
      const { sessionToken } = data.data;
      setLoading(false);
      dispatch({
        type: actionTypes.LOGIN_SUCCESS,
        payload: {
          userInfo: {
            ...data.data,
            isAuthenticated: true
          },
          sessionToken
        }
      });
    } catch (error) {
      setLoading(false);
      if (error.response) {
        errorAlert(error.response.data.message);
      } else {
        errorAlert('Something went wrong!');
      }
    }
  };
  const initialValues = {
    email: '',
    password: ''
  };
  return (
    <div className='app flex-row align-items-center'>
      {loading && <Loader />}
      <Container>
        <Row className='justify-content-center'>
          <Col md='6'>
            <CardGroup>
              <Card className='p-4'>
                <CardBody>
                  <Formik
                    validationSchema={LoginSchema}
                    onSubmit={handleSubmit}
                    initialValues={initialValues}
                  >
                    {props => {
                      const { handleSubmit, isSubmitting } = props;
                      return (
                        <Form onSubmit={handleSubmit}>
                          <FormGroup>
                            <Field
                              type='email'
                              name='email'
                              label='Email Address'
                              autoComplete='off'
                              component={InputField}
                            />
                          </FormGroup>
                          <FormGroup>
                            <Field
                              type='password'
                              name='password'
                              label='Password'
                              autoComplete='off'
                              component={InputField}
                            />
                          </FormGroup>
                          <Button type='submit' color='primary' disabled={isSubmitting}>
                            Log in
                          </Button>
                        </Form>
                      );
                    }}
                  </Formik>
                </CardBody>
              </Card>
            </CardGroup>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
